import { formatDateTime } from '../utils/formatDate.js';

/** Collapse nbsp and other wide whitespace so a preview cannot stretch the row. */
function emailLine(value) {
  return String(value ?? '').replace(/[\u00a0\u2000-\u200b\u202f\u205f\u3000]+/g, ' ').replace(/[ \t]{2,}/g, ' ').trim();
}

/**
 * @param {{ data: { configured?: boolean, mailbox?: string, items?: Array<any>, error?: string } | null, loading?: boolean, onOpen?: (email: any) => void }} props
 */
export function MailboxEmailsList({ data, loading, onOpen }) {
  if (loading) return <p className="muted">Loading emails…</p>;
  if (!data) return null;

  if (!data.configured) {
    return (
      <p className="muted small">
        {data.error || 'Microsoft Graph mailbox is not configured. Ask your agency to set up Mail.Read in Integrations.'}
      </p>
    );
  }

  if (data.error && !data.items?.length) {
    return <p className="err small">{data.error}</p>;
  }

  if (!data.items?.length) {
    return <p className="muted">No matching emails found.</p>;
  }

  return (
    <ul className="list-plain" data-tour="mailbox-list">
      {data.items.map((e) => (
        <li key={e.id} className="auth-card flat" style={{ marginBottom: '0.75rem' }}>
          <div className="mailbox-email-row">
            <div className="mailbox-email-copy">
              <strong>{emailLine(e.subject) || '(no subject)'}</strong>
              {!e.is_read ? <span className="badge badge-warn"> unread</span> : null}
              <div className="muted small">
                {emailLine(e.from_name) || e.from_email}
                {e.from_email ? ` · ${e.from_email}` : ''}
              </div>
              {e.preview ? <p className="muted small" style={{ marginBottom: 0 }}>{emailLine(e.preview)}</p> : null}
              <div className="muted small">{formatDateTime(e.received_at)}</div>
            </div>
            {onOpen ? (
              <button type="button" className="btn-link small mailbox-email-open" onClick={() => onOpen(e)}>
                Open
              </button>
            ) : null}
          </div>
        </li>
      ))}
    </ul>
  );
}

/**
 * @param {{ data: { configured?: boolean, items?: Array<any>, error?: string } | null, loading?: boolean }} props
 */
export function MailboxMeetingsList({ data, loading }) {
  if (loading) return <p className="muted">Loading meetings…</p>;
  if (!data) return null;

  if (!data.configured) {
    return (
      <p className="muted small">
        {data.error || 'Microsoft Graph calendar is not configured.'}
      </p>
    );
  }

  if (data.error && !data.items?.length) {
    return <p className="err small">{data.error}</p>;
  }

  if (!data.items?.length) {
    return <p className="muted">No upcoming meetings.</p>;
  }

  return (
    <ul className="list-plain" data-tour="mailbox-list">
      {data.items.map((m) => (
        <li key={m.id} className="auth-card flat" style={{ marginBottom: '0.75rem' }}>
          <strong>{m.subject}</strong>
          {m.is_online ? <span className="badge badge-ok"> Teams</span> : null}
          <div className="muted small">
            {m.start_at ? `Starts ${formatDateTime(m.start_at)}` : ''}
            {m.end_at ? ` · ends ${formatDateTime(m.end_at)}` : ''}
          </div>
          {m.organizer_name ? <div className="muted small">Organizer: {m.organizer_name}</div> : null}
          {m.join_url ? (
            <a href={m.join_url} target="_blank" rel="noreferrer" className="btn-secondary btn-sm" style={{ marginTop: '0.5rem', display: 'inline-block' }}>
              Join meeting
            </a>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
